import React from 'react';
import ShowVault from '../ethereum/ShowVaults';

function DefaultPage(){


	return <div><ShowVault /></div>;

	
	/*return (

    <div><ConnectR /></div>
    );*/
}

export default DefaultPage;